import { createSignal } from '@react-rxjs/utils'
import { catchError, switchMap } from 'rxjs'
import { fromFetch } from 'rxjs/fetch'

import { coerceCaughtToLeft } from '../../utils/rx/errors'
import { fetchResponseToJsonResult, headers } from '../fetch'

/**
 * AWS Events are used internally (first-party) for tracking & statistics.
 * They are sent to an AWS Gateway API, processed by a Lambda function,
 * and stored in an S3 bucket where they can be queried with Athena.
 */
export interface AwsEventData {
  netSuiteId?: string
  auth0Id?: string
  email?: string
  practitionerCode?: string
  dispensarySlug?: string
  userAgent?: string
  origin?: string
  ipAddress?: string
  operatingSystem?: string
  time?: Date
}

export interface CommissionsEventNotificationDismissed extends AwsEventData {
  eventKey: 'commissionsNotificationDismissed'
}
export interface CommissionsEventNotificationNavigatedToSubmit extends AwsEventData {
  eventKey: 'commissionsNotificationNavigatedToSubmit'
}
export interface CommissionsEventNotificationNavigatedToOptOut extends AwsEventData {
  eventKey: 'commissionsNotificationNavigatedToOptOut'
}

export type AwsEvent =
  | CommissionsEventNotificationDismissed
  | CommissionsEventNotificationNavigatedToSubmit
  | CommissionsEventNotificationNavigatedToOptOut

export type AwsEventKeys = AwsEvent['eventKey']

export const [awsEvent$, setAwsEvent] = createSignal<AwsEvent>()

const merciUrl = process.env.GATSBY_MERCI_URL || 'https://merci.api.dfh.dev'

// create immediate subscription to observable
if (typeof window !== 'undefined') {
  awsEvent$
    .pipe(
      switchMap(async (data) => ({
        body: JSON.stringify({ ...data }),
        method: 'PUT',
        headers: {
          ...headers.acceptJson,
          ...headers.contentTypeJson,
        },
      })),
      switchMap((payload) => fromFetch(`${merciUrl}/events`, payload)),
      switchMap(fetchResponseToJsonResult),
      catchError(coerceCaughtToLeft),
    )
    .subscribe()
}
